import React from 'react';

const TeamPerformance = () => {
  const skills = [
    { name: "Best Performance", percentage: 97 },
    { name: "Cloud Computing", percentage: 53 },
    { name: "Fast Server", percentage: 77 },
  ];

  return (
    <section className="py-20 px-6 max-w-7xl mx-auto border-t border-white/5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        
        {/* Left Column: Progress Bars */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 leading-tight">
            Best Performance System <br />
            <span className="text-electric-green">with Our Team</span>
          </h2>
          
          <div className="space-y-8">
            {skills.map((skill, index) => (
              <div key={index}>
                <div className="flex justify-between text-sm font-bold text-white mb-2">
                  <span>{skill.name}</span>
                  <span>{skill.percentage}%</span>
                </div>
                {/* Progress Bar Background */}
                <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
                  {/* Glowing Progress Bar Fill */}
                  <div 
                    className="bg-electric-green h-2 rounded-full shadow-[0_0_10px_rgba(57,255,20,0.6)]" 
                    style={{ width: `${skill.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column: Abstract Glass Illustration */}
        <div className="relative flex justify-center md:justify-end">
          {/* Subtle Glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-electric-green/10 rounded-full blur-[80px]"></div>
          
          {/* Mockup Card */}
          <div className="relative w-full max-w-sm bg-[#1A1F29]/60 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
            {/* Fake UI Elements for visual interest */}
            <div className="flex gap-2 mb-6 border-b border-white/10 pb-4">
              <div className="w-3 h-3 rounded-full bg-white/20"></div>
              <div className="w-3 h-3 rounded-full bg-white/20"></div>
              <div className="w-3 h-3 rounded-full bg-white/20"></div>
            </div>
            
            {/* Fake Chart Lines */}
            <div className="h-32 relative border-b border-l border-white/20 mb-4 flex items-end justify-between px-2">
               <div className="w-8 bg-electric-green/40 rounded-t h-[40%]"></div>
               <div className="w-8 bg-electric-green/60 rounded-t h-[70%]"></div>
               <div className="w-8 bg-electric-green shadow-[0_0_15px_rgba(57,255,20,0.5)] rounded-t h-[95%]"></div>
               <div className="w-8 bg-electric-green/30 rounded-t h-[50%]"></div>
            </div>
            <div className="flex items-center gap-4 mt-6">
                <div className="w-12 h-12 rounded-full border-2 border-electric-green flex items-center justify-center">
                    <svg className="w-6 h-6 text-electric-green" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                </div>
                <div className="flex-1 space-y-2">
                    <div className="w-full h-2 bg-gray-600/50 rounded"></div>
                    <div className="w-2/3 h-2 bg-gray-600/50 rounded"></div>
                </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TeamPerformance;